<app-dashboard-card title="Revenue Summary" icon="pi pi-chart-line">
	<span dashboardCardActions class="revenue-sample-badge">
		<i class="pi pi-clone" aria-hidden="true"></i>
		Sample Data
	</span>

	<div class="revenue-sample-notice" role="note">
		<i class="pi pi-info-circle" aria-hidden="true"></i>
		<div>
			<p>Contact Support to find out if this add-on is available for your property.</p>
		</div>
	</div>

	<div class="revenue-table-wrapper">
		<table
			class="revenue-table"
			aria-label="Sample revenue figures, not actual property revenue"
		>
			<thead>
				<tr>
					<th scope="col">Revenue</th>
					<th scope="col">Day</th>
					<th scope="col">Last Year</th>
					<th scope="col">Budget</th>
				</tr>
			</thead>
			<tbody>
				<tr
					*ngFor="let row of rows; first as isFirst"
					[class.revenue-total]="isFirst"
				>
					<th scope="row">{{ row.label }}</th>
					<td>{{ row.day | number: '1.0-0' }}</td>
					<td>{{ row.lastYear | number: '1.0-0' }}</td>
					<td>{{ row.budget | number: '1.0-0' }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</app-dashboard-card>
